export const WIDGET_THEMES = {
  light: 'light',
  dark: 'dark'
};
